import { Container, Row, Col, Card, Button, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileArrowDown,
  faClipboardList,
  faMagnifyingGlass,
  faArrowRight,
  faGlobe,
  faHeadset,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import FileIndexSearch from "../Pages/FileIndexSearch";

export default function SubNav() {
  const navigate = useNavigate();

  const quickTiles = [
    {
      title: "Downloadable forms",
      description: "Find templates, checklists, and reports ready to use.",
      icon: faFileArrowDown,
      buttonVariant: "secondary",
      buttonText: "Browse forms",
      action: () => navigate("/downloads"),
    },
    {
      title: "Policies & guides",
      description: "Review procedures, policies, and reference material.",
      icon: faClipboardList,
      buttonVariant: "primary",
      buttonText: "Open documents",
      action: () => navigate("/viewFiles"),
    },
    {
      title: "Quick index",
      description: "Need a different folder? Open the full index and explore.",
      icon: faMagnifyingGlass,
      buttonVariant: "dark",
      buttonText: "Browse index",
      action: () => navigate("/index"),
    },
  ];

  const helpfulLinks = [
    {
      label: "NCA Website",
      icon: faGlobe,
      external: "https://www.nobilitycare.com.au",
    },
    {
      label: "NDIS Portal",
      icon: faPeopleGroup,
      external: "https://www.ndis.gov.au",
    },
    {
      label: "Need help? Email leadership",
      icon: faHeadset,
      external: "mailto:support@nobilitycare.com.au",
    },
  ];

  const handleLinkClick = (link) => {
    if (link.internal) {
      navigate(link.internal);
      return;
    }
    if (link.external) {
      window.open(link.external, "_blank", "noopener");
    }
  };

  return (
    <section className="py-5">
      <Container fluid="lg">
        <Row className="g-4 mb-1">
          {quickTiles.map((tile) => (
            <Col key={tile.title} md={6} lg={4}>
              <Card className="h-100 border-0 rounded-4 shadow-sm bg-white">
                <Card.Body className="d-flex flex-column">
                  <span className="badge rounded-pill text-bg-light text-primary-emphasis mb-3 px-3 py-2 fs-5 shadow-sm">
                    <FontAwesomeIcon icon={tile.icon} />
                  </span>
                  <Card.Title className="mb-2">{tile.title}</Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {tile.description}
                  </Card.Text>
                  <Button
                    variant={tile.buttonVariant}
                    onClick={tile.action}
                    className="mt-3 align-self-start"
                  >
                    <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                    {tile.buttonText}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="g-4 align-items-stretch">
          <Col lg={7}>
            <Card className="h-100 border-0 rounded-4 shadow-sm bg-white">
              <Card.Header className="bg-transparent border-0 fw-semibold text-uppercase small text-muted">
                Quick search
              </Card.Header>
              <Card.Body>
                <p className="text-muted small mb-3">
                  Start typing the name of a document to download it instantly.
                </p>
                <FileIndexSearch mini />
              </Card.Body>
            </Card>
          </Col>
          <Col lg={5}>
            <Card className="h-100 border-0 rounded-4 shadow-sm bg-white d-flex">
              <Card.Header className="bg-transparent border-0 fw-semibold text-uppercase small text-muted">
                Helpful links
              </Card.Header>
              <ListGroup variant="flush" className="flex-grow-1">
                {helpfulLinks.map((link) => (
                  <ListGroup.Item
                    key={link.label}
                    action
                    onClick={() => handleLinkClick(link)}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div className="d-flex align-items-center">
                      <span className="badge rounded-pill text-bg-light text-primary-emphasis fw-semibold me-3 px-3 py-2 shadow-sm">
                        <FontAwesomeIcon icon={link.icon} />
                      </span>
                      <span>{link.label}</span>
                    </div>
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-secondary"
                    />
                  </ListGroup.Item>
                ))}
              </ListGroup>
              <Card.Footer className="bg-light border-0 text-muted small rounded-bottom">
                Quick tip: downloads are logged automatically for compliance.
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
